<template>
  <div class="grid grid-cols-3 pt-6">
    <div
      class="text-lg font-medium bg-blue-200 uppercase p-3 border-solid border-r-2 text-gray-700"
      v-for="label in ['Attribute Name', 'Type', 'Description']"
      :key="label"
    >
      {{ label }}
    </div>
  </div>
  <div class="grid grid-cols-3" v-for="(item, index) in fieldList" :key="index">
    <div class="text-lg font-medium text-left p-3 border-solid border-r-2 text-gray-700" :class="{ 'bg-gray-100': isEven(index) }">
      {{ item.label }}
    </div>
    <div class="text-lg font-thin text-left p-3 border-solid border-r-2 text-gray-700" :class="{ 'bg-gray-100': isEven(index) }">
      {{ item.type }}
    </div>
    <div class="text-lg font-thin text-left p-3 border-solid border-r-2 text-gray-700" :class="{ 'bg-gray-100': isEven(index) }">
      {{ item.description }}
    </div>
  </div>
  <span v-if="fieldList.length === 0" class="p6 text-lg text-gray-500">No attributes found</span>
</template>

<script>
import { computed } from 'vue'
import { isEven } from '@/services/common/helpers'

export default {
  name: 'DataFields',
  props: {
    fields: {
      required: true,
    },
  },
  setup(props) {
    const fieldList = computed(() => {
      const l = []
      for (const [key, value] of Object.entries(props.fields)) {
        l.push({
          label: key,
          description: value.description,
          type: value.type,
        })
      }
      return l
    })

    return { fieldList, isEven }
  },
}
</script>

<style scoped>

</style>
